import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "name", "remove", "submit"]

  connect() {
    console.log('Attachment controller connected')
  }

  // When file is selected
  handleChange(event) {
    const file = event.target.files[0]

    if (file) {
      this.nameTarget.textContent = file.name
      this.removeTarget.classList.remove("hidden")

      // Enable submit button if it exists
      if (this.hasSubmitTarget) {
        this.submitTarget.disabled = false
      }
    } else {
      this.clearAttachment()
    }
  }

  // Remove attachment
  remove(event) {
    event.preventDefault()

    // Clear file input
    this.inputTarget.value = ''
    this.nameTarget.textContent = ''
    this.removeTarget.classList.add("hidden")

    // Disable submit if textarea is empty
    if (this.hasSubmitTarget) {
      const textarea = document.querySelector('.new-message-container textarea')
      if (textarea && textarea.value === '') {
        this.submitTarget.disabled = true
      }
    }
  }

  clearAttachment() {
    this.nameTarget.textContent = 'No file selected'
    this.removeTarget.classList.add("hidden")
  }
}